import React from "react";
import {IconButton, ListItemText} from "@mui/material";
import FileService from "../../services/file.service";
import {saveAs} from "../../util/file";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store";
import {setErrorMessage} from "../../store/reducers/message";
import {FileMetadata} from "../../gen/api";
import FileDownloadIcon from '@mui/icons-material/FileDownload';

type Props = {
  form: FileMetadata
}

function FileDownload({form}: Props) {
  const dispatch = useDispatch<AppDispatch>();

  function downloadForm(id: string) {
    FileService.downloadFile(id).then(form =>
        saveAs(form.data, form.fileName)
    ).catch(_ =>
        dispatch(setErrorMessage("Die Datei konnte nicht heruntergeladen werden. Bitte versuchen Sie es später erneut."))
    )
  }

  return (
      <>
        <IconButton onClick={_ => downloadForm(form.id!)} color="primary">
          <FileDownloadIcon/>
        </IconButton>
        <ListItemText secondary={form.name}/>
      </>
  );
}

export default FileDownload;